export default __webpack_public_path__ + "static/media/Head_2_Ear_3_C1.5a04b2e4.svg";